module.exports = __webpack_public_path__ + "img/ЗВ-13(КВ)-008-m.988c0077.png";